
import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { dasa } from 'src/classess/dasaClasses';

export interface Area    { id:number; storeId:number; description:string; }
export interface Table   { id:number; storeId:number; areaId:number; tableName:string; seatingCapacity:number; }
export interface AreaDTO { storeId:number; name:string }
export interface TableDTO{ storeId:number; areaId:number; tableName:string; seatingCapacity:number; tableDetailsJson:string }

@Injectable({ providedIn:'root' })
export class OrderService {
  private base = environment.NEW_BACKEND_URL;
  constructor(private http: HttpClient){}

  getCategories(storeId: number,businessId: number) {
    return this.http.post<dasa.Category[]>(
      `${this.base}getCategories`,
      { storeId ,businessId}  // send as body
    );
  }
  getAllCategories(storeId: number,businessId: number) {
    return this.http.post<dasa.Category[]>(
      `${this.base}getAllCategories`,
      { storeId ,businessId}  // send as body
    );
  }
  getAllStoreItems(storeId:number) {
    return this.http.post<dasa.Category[]>(`${this.base}store/getAllItems`, {},{ params: new HttpParams().set('storeId',storeId) });
  }

}
